import React, { useState, useEffect } from 'react';
import { localStorage } from '@fiverr-private/futile';
import { I18n } from '@fiverr-private/i18n-react';
import { SEEN_TAB_EDUCATION_MODAL } from './constants';
import './style.scss';

const EducationModal = () => {
    const [showModal, setShowModal] = useState(false);

    const closeEducationModal = () => {
        localStorage.set(SEEN_TAB_EDUCATION_MODAL, 'true');

        setShowModal(false);
    };

    useEffect(() => {
        const hasSeenTabEducationModal = localStorage.get(SEEN_TAB_EDUCATION_MODAL);
        setShowModal(!hasSeenTabEducationModal);
    }, []);

    return (
        showModal && (
            <div className="education-modal">
                <div className="content">
                    <h6>
                        <I18n k="logo_maker_perseus.choose_variation.education_modal.title" />
                    </h6>
                    <p>
                        <I18n k="logo_maker_perseus.choose_variation.education_modal.description" />
                    </p>
                </div>
                <div className="navigation flex-end">
                    <button onClick={closeEducationModal}>
                        <I18n k="logo_maker_perseus.choose_variation.education_modal.got_it" />
                    </button>
                </div>
            </div>
        )
    );
};

export default EducationModal;
